export default "__VITE_ASSET__DxrjOwA8__"